import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Label, FormGroup, FormHeading } from '@sopranodesign/pulse-components';
import { WysiwygEditor } from '@sopranodesign/pulse-edit';
import {
  TemplatingTextInput,
  TemplatingTextArea
} from '@sopranodesign/pulse-templating';

import { useComposer } from '../../../../hooks/index';

const ContentInput = ({
  rtl = 'ltr'
}) => {
  const {
    response: { content },
    dispatch
  } = useComposer();

  const handleTextChange = value => {
    dispatch({ type: 'UPDATE_CONTENT', newContent: { text: value } });
  };

  const handleButtonChange = value => {
    dispatch({ type: 'UPDATE_CONTENT', newContent: { button: value } });
  };

  const handleTitleChange = value => {
    dispatch({ type: 'UPDATE_CONTENT', newContent: { title: value } });
  };

  const handleContentChange = useCallback(
    value => {
      dispatch({ type: 'UPDATE_CONTENT', newContent: { markdown: value } });
    },
    [dispatch]
  );

  return (
    <>
      <FormGroup>
        <Label htmlFor="message">Message</Label>
        <TemplatingTextArea
          rtl={rtl}
          id="message"
          name="message"
          value={content.text}
          onChange={handleTextChange}
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="button-label">Button Label</Label>
        <TemplatingTextInput
          rtl={rtl}
          id="button-label"
          name="button-label"
          value={content.button}
          onChange={handleButtonChange}
        />
      </FormGroup>
      <FormHeading>Content</FormHeading>
      <FormGroup>
        <Label htmlFor="title">Title</Label>
        <TemplatingTextInput
          rtl={rtl}
          id="title"
          name="title"
          value={content.title}
          onChange={handleTitleChange}
        />
      </FormGroup>
      <FormGroup>
        <Label>Body</Label>
        <WysiwygEditor
          value={content.markdown}
          onChange={handleContentChange}
          aria-label="body"
        />
      </FormGroup>
    </>
  );
};

ContentInput.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr'])
};

export default ContentInput;
